import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import SectionsContainer from 'pages/searchPage/components/sectionsContainer';
import { map } from 'lodash-es';
import SectionContainer from 'pages/searchPage/components/sectionContainer';
import FolderItem from 'pages/searchPage/components/folderItem/folderitem';
import { SearchResultModel } from 'entities/searchResult/model/searchResultModel';
import { Box } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import BlockHeader from 'pages/components/blockHeader';
import { SortingValue } from 'shared/lib/components/controls/sorting/sortingControl';

export type BaseSearchResultsProps = {
  results: SearchResultModel[];
  sort: SortingValue | null;
};

export default observer(function BaseSearchResults({
  results,
  sort,
}: BaseSearchResultsProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <SectionsContainer>
      {map(results, (result) => {
        if (!result.matchedFolders.length && !result.documentsCount) {
          return null;
        }

        return (
          <SectionContainer
            key={result.section.id}
            name={result.section.name || ''}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: sp.s80 }}>
              {result.matchedFolders.length ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <BlockHeader
                    size="medium"
                    text="Папки:"
                    secondText={`${result.matchedFolders.length}`}
                  ></BlockHeader>

                  {map(result.matchedFolders, (folder) => (
                    <FolderItem
                      key={folder.id}
                      folderModel={folder}
                      sort={sort}
                      isOnlyFolder
                    ></FolderItem>
                  ))}
                </Box>
              ) : null}

              {result.documentsCount ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <BlockHeader
                    size="medium"
                    text="Документы:"
                    secondText={`${result.documentsCount}`}
                  ></BlockHeader>
                  {map(result.withFilesfolders, (folder) => (
                    <FolderItem
                      sort={sort}
                      key={folder.id}
                      folderModel={folder}
                    ></FolderItem>
                  ))}
                </Box>
              ) : null}
            </Box>
          </SectionContainer>
        );
      })}
    </SectionsContainer>
  );
});
